import { Button, CircularProgress } from "@mui/material";
import { GetAppRounded } from "@mui/icons-material";
import { green, greenLight } from "../../theme/colors";

export default function DownloadExcelButton({
  onClick,
  label = "Download Excel",
  loading = false,
}: {
  onClick: () => void;
  label?: string;
  loading?: boolean;
}) {
  return (
    <Button
      variant="outlined"
      disabled={loading}
      startIcon={
        loading ? (
          <CircularProgress size={16} sx={{ color: green }} />
        ) : (
          <GetAppRounded sx={{ height: 18, width: 18 }} />
        )
      }
      onClick={onClick}
      sx={{
        borderColor: green,
        color: green,
        borderRadius: 2,
        textTransform: "none",
        fontWeight: 600,
        "&:hover": { borderColor: green, bgcolor: greenLight },
      }}
    >
      {label}
    </Button>
  );
}
